"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ADD_MAIL: function() {
        return ADD_MAIL;
    },
    DELETE_MAIL: function() {
        return DELETE_MAIL;
    },
    DUPLICATE_MAIL: function() {
        return DUPLICATE_MAIL;
    },
    GENERATE_MAILS: function() {
        return GENERATE_MAILS;
    },
    PRODUCTION_COMPLETE_MAIL: function() {
        return PRODUCTION_COMPLETE_MAIL;
    },
    RESET_MAILS: function() {
        return RESET_MAILS;
    },
    UPDATE_MAIL: function() {
        return UPDATE_MAIL;
    }
});
const ADD_MAIL = "ADD_MAIL";
const UPDATE_MAIL = "UPDATE_MAIL";
const DELETE_MAIL = "DELETE_MAIL";
const GENERATE_MAILS = "GENERATE_MAILS";
const RESET_MAILS = "RESET_MAILS";
const DUPLICATE_MAIL = "DUPLICATE_MAIL";
const PRODUCTION_COMPLETE_MAIL = "PRODUCTION_COMPLETE_MAIL";
